import Feeds from './FeedsApp';

export default Feeds;
